import { getErrorMessage } from 'src/auth/utils';

import { AMPLIFY_CONFIG_STORAGE_KEY } from './constant';

export type AmplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: string;
      userPoolClientId: string;
      loginWith: {
        oauth: {
          domain: string;
          scopes: string[];
          redirectSignIn: string[];
          redirectSignOut: string[];
          responseType: 'code' | 'token';
        };
      };
    };
  };
};

export function storeAmplifyConfig(config: AmplifyConfig) {
  try {
    localStorage.setItem(AMPLIFY_CONFIG_STORAGE_KEY, JSON.stringify(config));
  } catch (error) {
    getErrorMessage(error);
  }
}

export function getStoredAmplifyConfig(): AmplifyConfig | null {
  try {
    const stored = localStorage.getItem(AMPLIFY_CONFIG_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    getErrorMessage(error);
    return null;
  }
}

export function clearAmplifyConfig() {
  try {
    localStorage.removeItem(AMPLIFY_CONFIG_STORAGE_KEY);
  } catch (error) {
    getErrorMessage(error);
  }
}
